export function setDocuments (state, { competitionId, documents }) {
	const existingCompetitionIndex = state.competitions.findIndex(competition => competition.id === competitionId);

	if (existingCompetitionIndex >= 0) {
		return state.competitions[existingCompetitionIndex].documents = documents;
	}
}
